/*jshint -W069 */
/**
 *
 * @class Api
 * @param {(string|object)} [domainOrOptions] - The project domain or options object. If object, see the object's optional properties.
 * @param {string} [domainOrOptions.domain] - The project domain
 * @param {object} [domainOrOptions.token] - auth token - object with value property and optional headerOrQueryName and isQuery properties
 */
var Api = (function() {
  'use strict';

  var Q = require('q');
  var settingsInstance = require('./SettingsInstance.js');
  var customRequest = require('./requestHelper.js').customRequest;
  var mergeQueryParams = require('./requestHelper.js').mergeQueryParams;

  function Api(options) {
    var domain = typeof options === 'object' ? options.domain : options;
    this.domain = domain ? domain : settingsInstance.baseApiNewUrl;
    if (this.domain.length === 0) {
      throw new Error('Domain parameter must be specified as a string.');
    }
  }

  /**
   * HTTP Request
   * @method
   * @name Api#request
   * @param {string} method - http method
   * @param {string} path - path
   * @param {string} url
   * @param {object} body - body parameters / object
   * @param {object} headers - header parameters
   * @param {object} queryParameters - querystring parameters
   * @param {object} form - form data object
   * @param {object} deferred - promise object
   */
  Api.prototype.request = customRequest;

  /**
   * Pobierz listę pasujących użytkowników z uprawnieniami Users_search i Users_search_all
   * @method
   * @name Api#getCboUsers
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.filter_str - Treść filtra
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getCboUsers = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/cbo_users',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (
      parameters['filter_str'] !== undefined &&
      parameters['filter_str'] !== ''
    ) {
      queryParameters['filter_str'] = parameters['filter_str'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz listę pasujących użytkowników z uprawnieniami Registry_of_export_data i Registry_of_export_data_all
   * @method
   * @name Api#getCboUsersExport
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.filter_str - Treść filtra
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getCboUsersExport = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/cbo_users/export',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['filter_str'] !== undefined) {
      queryParameters['filter_str'] = parameters['filter_str'];
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz listę pasujących użytkowników z uprawnieniami Report_registry i Report_registry_all
   * @method
   * @name Api#getCboUsersRegistry
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.filter_str - Treść filtra
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getCboUsersRegistry = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/cbo_users/registry',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['filter_str'] !== undefined) {
      queryParameters['filter_str'] = parameters['filter_str'];
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz listę pasujących użytkowników z uprawnieniami Registry_of_data_supply i Registry_of_data_supply_all
   * @method
   * @name Api#getCboUsersSupply
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.filter_str - Treść filtra
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getCboUsersSupply = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/cbo_users/supply',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['filter_str'] !== undefined) {
      queryParameters['filter_str'] = parameters['filter_str'];
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  Api.prototype.getCboOrganizations = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/cbo_organizations',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (
      parameters['filter_str'] !== undefined &&
      parameters['filter_str'] !== null &&
      parameters['filter_str'].trim() !== '' &&
      parameters['filter_str'] !== ''
    ) {
      queryParameters['filter_str'] = parameters['filter_str'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  return Api;
})();

exports.Api = Api;
